import * as React from 'react';
import { Button } from '@antimatterhq/ui/components/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@antimatterhq/ui/components/dialog';
import { Input } from '@antimatterhq/ui/components/input';

interface SimpleInputDialogProps {
  title: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (value: string) => void;
}

const SimpleInputDialog: React.FC<SimpleInputDialogProps> = ({
  title,
  open,
  onOpenChange,
  onSubmit,
}) => {
  const [inputValue, setInputValue] = React.useState('');

  const handleSubmit = () => {
    // Handle the input value submission
    onSubmit(inputValue);
    setInputValue('');
    onOpenChange(false); // Close the dialog after submission
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <Input
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          placeholder="Type something..."
        />
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="ghost">Cancel</Button>
          </DialogClose>
          <Button onClick={handleSubmit}>Submit</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SimpleInputDialog;
